import { Component, OnInit } from '@angular/core';
import { CmsService } from '../cms.service';
import * as PrismicDOM from 'prismic-dom';
import { ConnectService } from '../connect.service';
import * as _ from 'lodash';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.css']
})
export class PortfolioComponent implements OnInit {

  public portfolio;
  public pages;


  public connect = () => this.connectService.toggleConnect(true);


  public generateMarkup(data) {
    return PrismicDOM.RichText.asHtml(data);
  }


  constructor(private cms: CmsService, public connectService: ConnectService, private titleService:Title) { }

  ngOnInit() {
    this.titleService.setTitle(`Portfolio -- ThinSlabz® by Rosetta Stone Group`);

    this.cms.getPortfolio().subscribe((response) => {
      this.portfolio = response;
      // console.log("Portfolio: ", response);
      if (this.portfolio.data.project && this.portfolio.data.project.length > 0) {
        this.pages = Array(Math.ceil(this.portfolio.data.project.length/3)).fill(1);
      }
    });

  }

}


// WEBPACK FOOTER //
// /tmp/build_0264da94/src/app/portfolio/portfolio.component.ts